<div class="d-flex flex-row flex-wrap" style="gap: 2.5rem;">
  <div class="d-flex flex-column">
    <span class="font-weight-bold">{{'lang.attributeToggles.device.productive' | translate}}</span>
    <sb-toggle-switch
      onText="{{ 'lang.globals.yes' | translate }}"
      offText="{{ 'lang.globals.no' | translate }}"
      [(model)]="productive">
    </sb-toggle-switch>
  </div>

  <div class="d-flex flex-column">
    <span class="font-weight-bold">{{'lang.deviceDetails.disabled' | translate}}</span>
    <sb-toggle-switch
      onText="{{ 'lang.globals.yes' | translate }}"
      offText="{{ 'lang.globals.no' | translate }}"
      [(model)]="disabled">
    </sb-toggle-switch>
  </div>
</div>

<div class="mt-4 d-flex flex-column">
  <span class="font-weight-bold">{{'lang.admin.device.machineCode' | translate}}</span>
  <sb-clipboard-list-input (entriesChanged)="onEntriesChanged($event)"></sb-clipboard-list-input>
</div>

<sb-button
  classes="btn-primary mt-4" (click)="done()">
  {{'lang.admin.licenceManagement.autoAssign.start' | translate}}
</sb-button>
